import { render, staticRenderFns } from "./PackageManage.vue?vue&type=template&id=59da6d88&scoped=true"
import script from "./PackageManage.vue?vue&type=script&lang=js"
export * from "./PackageManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da6d88",
  null
  
)

export default component.exports